module.exports = __webpack_public_path__ + "img/v3-xmleditor.838cb184.png";